import * as Types from './api';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SaveGroupMembershipMutationVariables = Types.Exact<{
  groupId: Types.Scalars['Int']['input'];
  numberId: Types.Scalars['Int']['input'];
  controllingLine: Types.Scalars['Boolean']['input'];
  state: Types.ControllingLineState;
}>;


export type SaveGroupMembershipMutation = { __typename?: 'Mutation', saveGroupMembership: { __typename?: 'SaveResult', errors?: Array<{ __typename?: 'Error', location: Array<string>, context?: string | null, type: string }> | null } };

export type DeletePickupGroupMutationVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
}>;


export type DeletePickupGroupMutation = { __typename?: 'Mutation', deletePickupGroup: Array<{ __typename?: 'Error', location: Array<string>, context?: string | null, type: string }> };


export const SaveGroupMembershipDocument = gql`
    mutation SaveGroupMembership($groupId: Int!, $numberId: Int!, $controllingLine: Boolean!, $state: ControllingLineState!) {
  saveGroupMembership(
    groupId: $groupId
    numberId: $numberId
    controllingLine: $controllingLine
    state: $state
  ) {
    errors {
      location
      context
      type
    }
  }
}
    `;
export type SaveGroupMembershipMutationFn = Apollo.MutationFunction<SaveGroupMembershipMutation, SaveGroupMembershipMutationVariables>;

/**
 * __useSaveGroupMembershipMutation__
 *
 * To run a mutation, you first call `useSaveGroupMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveGroupMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveGroupMembershipMutation, { data, loading, error }] = useSaveGroupMembershipMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      numberId: // value for 'numberId'
 *      controllingLine: // value for 'controllingLine'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useSaveGroupMembershipMutation(baseOptions?: Apollo.MutationHookOptions<SaveGroupMembershipMutation, SaveGroupMembershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveGroupMembershipMutation, SaveGroupMembershipMutationVariables>(SaveGroupMembershipDocument, options);
      }
export type SaveGroupMembershipMutationHookResult = ReturnType<typeof useSaveGroupMembershipMutation>;
export type SaveGroupMembershipMutationResult = Apollo.MutationResult<SaveGroupMembershipMutation>;
export type SaveGroupMembershipMutationOptions = Apollo.BaseMutationOptions<SaveGroupMembershipMutation, SaveGroupMembershipMutationVariables>;
export const DeletePickupGroupDocument = gql`
    mutation DeletePickupGroup($id: Int!) {
  deletePickupGroup(id: $id) {
    location
    context
    type
  }
}
    `;
export type DeletePickupGroupMutationFn = Apollo.MutationFunction<DeletePickupGroupMutation, DeletePickupGroupMutationVariables>;

/**
 * __useDeletePickupGroupMutation__
 *
 * To run a mutation, you first call `useDeletePickupGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePickupGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePickupGroupMutation, { data, loading, error }] = useDeletePickupGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePickupGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeletePickupGroupMutation, DeletePickupGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePickupGroupMutation, DeletePickupGroupMutationVariables>(DeletePickupGroupDocument, options);
      }
export type DeletePickupGroupMutationHookResult = ReturnType<typeof useDeletePickupGroupMutation>;
export type DeletePickupGroupMutationResult = Apollo.MutationResult<DeletePickupGroupMutation>;
export type DeletePickupGroupMutationOptions = Apollo.BaseMutationOptions<DeletePickupGroupMutation, DeletePickupGroupMutationVariables>;